export enum BaseDeviceMethods {
  INITIALIZE = 'INITIALIZE',
  DISCONNECT = 'DISCONNECT',
  HEALTH_CHECK = 'HEALTH_CHECK',
}

export enum CashDrawerDeviceMethods {
  OPEN = 'OPEN',
}

export enum MicrDeviceMethods {
  GET_CHECK_DETAILS = 'GET_CHECK_DETAILS',
}

export enum PrinterDeviceMethods {
  PRINT = 'PRINT',
}

export enum ScannerDeviceMethods {
  ENABLE = 'SET_DEVICE_ENABLE',
  DISABLE = 'SET_DEVICE_DISABLE',
  ENABLE_DATA_EVENTS = 'SET_DATA_EVENT_ENABLE',
}

export type RdsDeviceMethods =
  | BaseDeviceMethods
  | ScannerDeviceMethods
  | CashDrawerDeviceMethods
  | MicrDeviceMethods
  | PrinterDeviceMethods;

export enum RdsResponseType {
  INITIALIZATION = 'INITIALIZATION',
  DIRECT_IO = 'DIRECT_IO',
  ERROR = 'ERROR',
  OUTPUT_COMPLETE = 'OUTPUT_COMPLETE',
  STATUS_UPDATE = 'STATUS_UPDATE',
  DATA = 'DATA',
  HEALTH_CHECK_SUCCESS = 'HEALTH_CHECK_SUCCESS',
  HEALTH_CHECK_FAILURE = 'HEALTH_CHECK_FAILURE',
  NOT_SET = 'NOT_SET',
  SET_DEVICE_ENABLED = 'SET_DEVICE_ENABLED',
  SET_DATA_EVENT_ENABLED = 'SET_DATA_EVENT_ENABLED',
  CONNECTED = 'CONNECTED',
  PRINT = 'PRINT',
  PRINT_SLIP = 'PRINT_SLIP',
  PRINT_SLIP_REMOVE_TIME_OUT = 'PRINT_SLIP_REMOVE_TIME_OUT',
}

/*
These numbers are actual constants defined in the java JPOS package. They can be found in jpos.ScaleConst.
*/

export enum ScaleStatus {
  STABLE_WEIGHT = 'STABLE_WEIGHT',
  WEIGHT_UNSTABLE = 'WEIGHT_UNSTABLE',
  WEIGHT_ZERO = 'WEIGHT_ZERO',
  WEIGHT_OVERWEIGHT = 'WEIGHT_OVERWEIGHT',
  NOT_READY = 'NOT_READY',
  WEIGHT_UNDER_ZERO = 'WEIGHT_UNDER_ZERO',
  CONNECTED = 'CONNECTED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS',
}
